import { css } from '@emotion/react';
import { Gray } from '@constants/color';

export const container = css({
  width: '100%',
  height: '77vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: Gray.Gray90
});

export const loadingAnimation = css({
  width: 400,
  height: 400
});
